(function() {
  function init() {
    if (typeof Integration === 'undefined') {
      return;
    }

    const okendoCompile = Integration.compileIntegrationTemplate;

    Integration.compileIntegrationTemplate = function(data, itemHtml) {
      const reviewsHtml = `<div class="redo-review-stars" product_id="${data.id}"></div>`
      itemHtml = itemHtml.replace(/{{itemReviews}}/g, reviewsHtml);
      return itemHtml;
    };
  }
  init();
  document.addEventListener('DOMContentLoaded', init);
})();